<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model.trim="data.name"
        label="Category name"
        maxlength="255"
        required
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-autocomplete
        v-model="data.group_id"
        :items="groupOptions"
        :loading="loadingGroups"
        :disabled="loadingGroups"
        item-text="name"
        item-value="id"
        label="Group"
        placeholder="Select a group"
        clearable
        required
        :error-messages="groupError ? [groupError] : []"
      ></v-autocomplete>
      <v-btn v-if="groupError" small text color="primary" @click="loadGroups">
        Retry loading groups
      </v-btn>
    </v-col>
    <v-col v-if="data.slug" cols="12">
      <v-text-field
        :value="data.slug"
        label="URL slug"
        hint="Generated from the category name when saved."
        persistent-hint
        readonly
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { axios } from '../../../utils'

export default {
  name: 'CategoryForm',
  props: ['data'],
  data() {
    return { groups: [], loadingGroups: false, groupError: '' }
  },
  computed: {
    groupOptions() {
      const groups = this.groups.slice()
      const selected = this.data.group
      if (selected && !groups.some(group => group.id === Number(selected.id))) {
        groups.push({ id: Number(selected.id), name: selected.name })
      }
      return groups
    }
  },
  mounted() {
    this.loadGroups()
  },
  methods: {
    async loadGroups() {
      this.loadingGroups = true
      this.groupError = ''
      try {
        const response = await axios.get('api/admin/admin-groups', {
          params: { q: '' }
        })
        this.groups = response.data
          .filter(group => group && group.id != null)
          .map(group => ({ id: Number(group.id), name: group.name }))
      } catch (error) {
        this.groupError = 'Unable to load groups. Please try again.'
      } finally {
        this.loadingGroups = false
      }
    }
  }
}
</script>
